exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[type=text][data-v-31a10f6c]:not(.browser-default):focus:not([readonly]):not(.invalid),\ninput[type=password][data-v-31a10f6c]:not(.browser-default):focus:not([readonly]):not(.invalid) {\n    border: 1px solid #1c82bf;\n}\ninput[data-v-31a10f6c]:-webkit-autofill::placeholder,\ninput[data-v-31a10f6c]:-webkit-autofill::-webkit-input-placeholder {\n    display: none;\n}\n", ""]);

// exports
